import { LRUMap } from 'lru_map';
import { isNil } from '@lucidlink/tscore';
import { CRYPTO_IV_LENGTH, CRYPTO_KEY_LENGTH, CryptoAlgorithm } from '#block-store/types';
import { NotImplementedError } from '#common/types';
export const createAesCrypto = () => {
    return new WebCryptoAes();
};
class WebCryptoAes {
    static KEY_CACHE_SIZE = 10;
    static KEY_USAGES = ['decrypt', 'encrypt'];
    keyCache = new LRUMap(WebCryptoAes.KEY_CACHE_SIZE);
    ivRandomPart = crypto.getRandomValues(new Uint32Array(1));
    ivSeqId = 0n;
    async encrypt(unencrypted, cryptoKey, iv) {
        if (!iv) {
            iv = this.generateIv();
        }
        const encrypted = await crypto.subtle.encrypt({ name: CryptoAlgorithm.AES_GCM, iv }, await this.toWebCryptoKey(cryptoKey), unencrypted);
        return { iv, value: new Uint8Array(encrypted) };
    }
    async decrypt(encrypted, cryptoKey) {
        return new Uint8Array(await crypto.subtle.decrypt({
            name: CryptoAlgorithm.AES_GCM,
            iv: encrypted.iv,
        }, await this.toWebCryptoKey(cryptoKey), encrypted.value));
    }
    getHmac(_text, _key) {
        throw new NotImplementedError();
    }
    async generateKey() {
        const key = await crypto.subtle.generateKey({
            name: CryptoAlgorithm.AES_GCM,
            length: CRYPTO_KEY_LENGTH * 8,
        }, true, WebCryptoAes.KEY_USAGES);
        const rawKey = await crypto.subtle.exportKey('raw', key);
        return new Uint8Array(rawKey);
    }
    generateIv() {
        ++this.ivSeqId;
        const ivBuffer = new Uint8Array(CRYPTO_IV_LENGTH);
        const ivBufferDataView = new DataView(ivBuffer.buffer);
        ivBufferDataView.setBigUint64(0, this.ivSeqId, true);
        ivBufferDataView.setUint32(BigUint64Array.BYTES_PER_ELEMENT, this.ivRandomPart[0], true);
        return ivBuffer;
    }
    async toWebCryptoKey(key) {
        const cachedKey = this.keyCache.get(key);
        if (!isNil(cachedKey)) {
            return cachedKey;
        }
        const cryptoKey = await crypto.subtle.importKey('raw', key, { name: CryptoAlgorithm.AES_GCM }, false, WebCryptoAes.KEY_USAGES);
        this.keyCache.set(key, cryptoKey);
        return cryptoKey;
    }
}
